import CommissionServices from "../../services/CommissionServices";

const state = {    
    estados: [], 
    fuentes: [], 
    loadingCommission: false,
    commissionsSelected: [],
    commissionsVisualize: [],
    commissionsVisualizePdf: [],
    commissionsPdf: [],
    commissionsExcel: [],
    commissionsVisualizeExcel: [],
    permissionApproveAndBill: false,
    commissionsPreliquidation: [],
    commissionsLiquidation: [],
    commissionsPreliquidationQuery: [],
    broker: null,
    userId: null,
    apsId: null,
    commissionReport: [],
    squareCommissions: [],
    squareCommissionsPdf: [],
    squareCommissionsExcel: [],
    isBroker: false,
    preliquidationsExcel: [],
};

const getters = {
    estados: state => {
        return state.estados; 
    },    
    fuentes: state => {
        return state.fuentes; 
    },
    loadingCommission: state => {
        return state.loadingCommission;
    },
    commissionsSelected: state => {
        return state.commissionsSelected;
    },
    commissionsVisualize: state => {
        return state.commissionsVisualize;
    },
    commissionsVisualizePdf: state => {
        return state.commissionsVisualizePdf;
    },
    commissionsPdf: state => {
        return state.commissionsPdf;
    },
    commissionsExcel: state => {
        return state.commissionsExcel;
    },
    commissionsVisualizeExcel: state => {
        return state.commissionsVisualizeExcel;
    },
    permissionApproveAndBill: state => {
        return state.permissionApproveAndBill;
    },
    commissionsPreliquidation: state => {
        return state.commissionsPreliquidation;
    },
    commissionsLiquidation: state => {
        return state.commissionsLiquidation;
    },
    commissionsPreliquidationQuery: state => {
        return state.commissionsPreliquidationQuery;
    },
    broker: state => {
        return state.broker;
    },
    userId: state => {
        return state.userId;
    },
    apsId: state => {
        return state.apsId;
    },
    commissionReport: state => {
        return state.commissionReport
    },
    squareCommissions: state => {
        return state.squareCommissions;
    },
    squareCommissionsPdf: state => {
        return state.squareCommissionsPdf;
    },
    squareCommissionsExcel: state => {
        return state.squareCommissionsExcel;
    },
    preliquidationsExcel: state => {
        return state.preliquidationsExcel;
    },
    generatePreliquidationMassive: state => {
        return state.generatePreliquidationMassive;
    },
    generateLiquidationMassive: state => {
        return state.generateLiquidationMassive;
    },
    isBroker: state => {
        return state.isBroker;
    }
};

const actions = {
    estados(context) {
        context.commit("RECEIVE_ESTADOSFVC", { estadosFvc: [] });        
        return CommissionServices.getEstados()
            .then(res => { 
                console.log(res.data.Data);
                context.commit("RECEIVE_ESTADOSFVC", { estados: res.data.Data});          
            }).catch(function () {
            });
    },
    fuentes(context) {
        context.commit("RECEIVE_FUENTE", { fuentes: [] });        
        return CommissionServices.getFuentes()
            .then(res => { 
                context.commit("RECEIVE_FUENTE", { fuentes: res.data.Data});          
            }).catch(function () {
            });
    },
    updateCommissionSelected(context, payload) {
        state.commissionsSelected = payload;
    },
    getCommissionsVisualize(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.visualize(payload, apsUserName, agencyId, idApsVt)
            .then(res => {

                if (res.data.error == 0) {
                    state.commissionsVisualize = res.data.data.commissions;
                    var adjusment = res.data.data.adjustments;
                    var creditNotes = res.data.data.creditNotes;
                    var advances = res.data.data.advances;

                    creditNotes.forEach(element => {
                        // element.type="Nota de crédito"
                        state.commissionsVisualize.push(element)
                    });
                    adjusment.forEach(element => {
                        //  element.type="Ajustes"
                        state.commissionsVisualize.push(element)
                    });
                    advances.forEach(element => {
                        //  element.type="Avances"
                        state.commissionsVisualize.push(element)
                    });
                } else {
                    context.commit("updateNotificationError", "No se pudo obtener información para visualizar");
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    sendCommissionsPreliquidationGeneration(context) {
        context.commit("showLoadingCommissionIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.preliquidationGeneration(null, apsUserName, agencyId, idApsVt)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    sendCommissionsPreliquidationApprove(context, selectedCommision) {
        let data = [selectedCommision];
        context.commit("showLoadingCommissionIndicator");
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.preliquidationApprove(data, idApsVt, agencyId)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    sendCommissionsPreliquidationApproveAndBill(context, selectedCommision) {
        let data = [selectedCommision];
        context.commit("showLoadingCommissionIndicator");
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.preliquidationApproveAndBill(data, idApsVt, agencyId)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    sendCommissionsPreliquidationReject(context, selectedCommision) {
        let data = [selectedCommision];
        context.commit("showLoadingCommissionIndicator");
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.preliquidationReject(data, idApsVt, agencyId)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsMassive(context) {
        context.commit("showLoadingCommissionIndicator");
        const apsId = context.rootGetters.userIdIAM.user_id;
        const agencyId= context.rootGetters.agencyId;
        const email = context.rootGetters.userProfile.email;
        return CommissionServices.commissionsMassive(apsId, agencyId, email)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    generatePreliquidationMassive(context, idPreliquidation) {
        context.commit("showLoadingCommissionIndicator");
        const id = idPreliquidation;
        const email = context.rootGetters.userProfile.email;
        console.log("id: " + id);
        console.log("email: " + email);
        return CommissionServices.preliquidationMassive(id, email)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("notification", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    generateLiquidationMassive(context, idLiquidation) {
        context.commit("showLoadingCommissionIndicator");
        const id = idLiquidation;
        const email = context.rootGetters.userProfile.email;
        return CommissionServices.liquidationMassive(id, email)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("notification", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsVisualizePDF(context) {
        context.commit("showLoadingCommissionIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.visualizePdf(apsUserName, idApsVt, agencyId)
            .then(res => {

                state.commissionsVisualizePdf = res.data;
                return res.data
            }).catch(err => {
                state.commissionsVisualizePdf = null;
                context.commit("updateNotificationError", "No se pudo generar pdf");
                return null;
            }).finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsPDF(context, ids) {
        context.commit("showLoadingCommissionIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        return CommissionServices.commissionsPdf(ids,apsUserName)
            .then(res => {
                state.commissionsPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsVisualizeExcel(context) {
        context.commit("showLoadingCommissionIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.visualizeExcel(apsUserName, idApsVt, agencyId)
            .then(res => {
                state.commissionsVisualizeExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsExcel(context, id) {
        context.commit("showLoadingCommissionIndicator");
        return CommissionServices.commissionsApprovalExcel(id)
            .then(res => {
                state.commissionsExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    validatePermission(context) {
        const apsRuc = context.rootGetters.userProfile.identity;
        return CommissionServices.validatePermission(apsRuc)
            .then((res) => {
                if (res.data.error == 0) {
                    state.permissionApproveAndBill = true;
                } else {
                    state.permissionApproveAndBill = false;
                }
            })
            .catch(() => {
                state.permissionApproveAndBill = false;
            })
    },
    getCommissionsLiquidation(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        let any = undefined;
        let dateOpts = undefined;
        if (typeof payload === "string") {
            any = payload;
        } else if (payload && typeof payload === "object") {
            any = payload.any;
            if (payload.fechaPagoDesde && payload.fechaPagoHasta) {
                dateOpts = {
                    fechaPagoDesde: payload.fechaPagoDesde,
                    fechaPagoHasta: payload.fechaPagoHasta
                };
            }
        }
        return CommissionServices.liquidation(any, idApsVt, agencyId, dateOpts)
            .then(res => {
                if (res.data.error == 0) {
                    state.commissionsLiquidation = res.data.data;
                    //console.log(res.data.data)
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsPreliquidation(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        return CommissionServices.preliquidation(payload,idApsVt,agencyId)
            .then(res => {
                if (res.data.error == 0) {
                    state.commissionsPreliquidation = res.data.data;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsPreliquidationQuery(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        const agencyId= context.rootGetters.agencyId;
        payload.IdAgencia = agencyId;
        payload.ApsUser = context.rootGetters.userProfile.user_name;
        payload.apsCode = context.rootGetters.userProfile.user_id;
        payload.Moneda = 1;
        return CommissionServices.preliquidationQuery(payload)
            .then(res => {
                if (res.data.error == 0) {
                    state.commissionsPreliquidationQuery = res.data.data.Data;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
     getPreliquidationsExcel(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        const agencyId = context.rootGetters.agencyId;
        payload.IdAgencia = agencyId;
        payload.ApsUser = context.rootGetters.userProfile.user_name;
        payload.apsCode = context.rootGetters.userProfile.user_id;
        payload.Moneda = 1;
        return CommissionServices.preliquidationQueryExcel(payload)
            .then(res => {
                let data = res.data;
                if (data && data.byteLength > 4) {
                    let bytes = new Uint8Array(data);
                    // Comprobar si es un string Base64 de un ZIP (empieza por 'UEsD')
                    if (bytes[0] === 85 && bytes[1] === 69 && bytes[2] === 115 && bytes[3] === 68) {
                        let base64String = "";
                        let chunkSize = 8192;
                        for (let i = 0; i < bytes.length; i += chunkSize) {
                            base64String += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
                        }
                        let binaryString = window.atob(base64String);
                        let len = binaryString.length;
                        let outBytes = new Uint8Array(len);
                        for (let i = 0; i < len; i++) {
                            outBytes[i] = binaryString.charCodeAt(i);
                        }
                        state.preliquidationsExcel = outBytes.buffer;
                        return;
                    }
                }
                state.preliquidationsExcel = data;
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    getCommissionsReport(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        const agencyId= context.rootGetters.agencyId;
        const idApsVt = context.rootGetters.userProfile.id_aps_vt;
        payload.agencia = agencyId;
        payload.agente = idApsVt;
        return CommissionServices.comissionReport(payload)
            .then(res => {
                if (res.data.error == 0) {
                    state.commissionReport = res.data.data.Data;
                    
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    
    getBroker(context){
        return state.broker = context.rootGetters.userProfile.business_name;
    },

    getUserId(context){
        return state.userId = context.rootGetters.userProfile.user_id;
    },

    getApsId(context){
        return state.apsId = context.rootGetters.userProfile.aps;
    },

    getSquareCommission(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        
        return CommissionServices.getSquareCommission(payload)
            .then(res => {

                if (res.data.error == 0) {
                    state.squareCommissions = res.data.data;
                } else {
                    context.commit("updateNotificationError", "No se pudo obtener información para visualizar");
                }
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },

    getSquareCommissionsPDF(context, payload) {
        context.commit("showLoadingCommissionIndicator");
        return CommissionServices.getSquareCommissionPdf(payload)
            .then(res => {
                state.squareCommissionsPdf = res.data;
                return res.data
            }).catch(err => {
                state.squareCommissionsPdf = null;
                context.commit("updateNotificationError", "No se pudo generar pdf");
                return null;
            }).finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },

    getSquareCommissionsExcel(context,payload) {
        context.commit("showLoadingCommissionIndicator");
        
        return CommissionServices.getSquareCommissionExcel(payload)
            .then(res => {
                state.squareCommissionsExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingCommissionIndicator");
            });
    },
    validateIsUserAgent(context, userId) {  
        return CommissionServices.IsUserAgent(userId)
            .then((respuesta) => {
                console.log(respuesta.data);
                const result = respuesta.data;
                context.commit("loadingAsBroker", {isBroker: respuesta.data != null});
                state.isBroker = respuesta.data != null;
            })
            .catch(() => {
    
            })
            .finally(() => {
                /*   context.commit("hideLoadingOrderEmissionIndicator"); */
        });
    },
};



const mutations = {
    RECEIVE_ESTADOSFVC(state, {estados}) {
        state.estados = estados
    },
    RECEIVE_FUENTE(state, {fuentes}) {
        state.fuentes = fuentes
    }, 
    showLoadingCommissionIndicator(state) {
        state.loadingCommission = true;
    },
    hideLoadingCommissionIndicator(state) {
        state.loadingCommission = false;
    },
    loadingAsBroker(state, {isBroker}) {
        state.isBroker = isBroker;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};